import type { Invoice } from '@/api/invoice'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFileAClaimStore = defineStore('claim', () => {
  const selectedInvoice = ref<Invoice | null>(null)

  function selectInvoice(data: Invoice) {
    selectedInvoice.value = data
  }

  return { selectedInvoice, selectInvoice }
})
